import { useEffect } from 'react';

/**
 * `Ctrl+K`/`Cmd+K` anywhere, and `/` when the focus is not on a text control (13 §7.3): both open
 * the global search palette. One listener per mounted layout, torn down with it.
 */
export function useSearchShortcut(onOpen: () => void): void {
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      const isMod = event.ctrlKey || event.metaKey;
      if (isMod && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        onOpen();
        return;
      }

      if (event.key === '/' && !isMod && !event.altKey) {
        const target = event.target;
        const element = target instanceof HTMLElement ? target : null;
        const tag = element?.tagName;
        const isTextControl =
          tag === 'INPUT' || tag === 'TEXTAREA' || element?.isContentEditable === true;
        if (isTextControl) {
          return;
        }
        event.preventDefault();
        onOpen();
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onOpen]);
}
